import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HTTP } from '@ionic-native/http/ngx';
import { Store } from '@ngrx/store';
import { AppState } from '../store/appState';
import { getLodeId, getJwtToken } from '../store/userPreferences';
import { ModalController, ToastController } from '@ionic/angular';
import jsonwebtoken from 'jsonwebtoken';
import { environment } from 'src/environments/environment';
import { v4 as uuidv4 } from 'uuid';
import { simplexCheckoutModal } from 'src/app/angular-wallet-base/utils';

import { pluck, take } from 'rxjs/operators';
import { EXTERNAL_APIS } from '../constants';
import { Logger } from './logger.service';
import { inspect } from 'util';
import { Observable } from 'rxjs';
@Injectable({
  providedIn: 'root',
})
export class CreditDebitCardService {
  private url = `${EXTERNAL_APIS.SIMPLEX}`;
  private partner = environment.SIMPLEX_PARTNER;
  private endUserId = uuidv4();

  constructor(
    private toastController: ToastController,
    private modalCntrl: ModalController,
    private http: HttpClient,
    public httpPlugin: HTTP,
    private store: Store<AppState>
  ) {}

  public async getJwt() {
    const jwt = await this.store.select(getJwtToken).pipe(take(1)).toPromise();
    return jwt;
  }

  public async getPriceQuoteTransaction(
    digitalCurrency: string,
    fiatCurrency: string = 'USD',
    requestedCurrency: string = 'USD',
    requestedAmount: number
  ) {
    try {
      const quotePayload = {
        digital_currency: digitalCurrency,
        fiat_currency: fiatCurrency,
        requested_currency: requestedCurrency,
        requested_amount: requestedAmount,
      };

      const jwt = await this.getJwt();
      const headers = new HttpHeaders({
        Authorization: `Bearer ${jwt}`,
      });

      let response = await this.http.post(`${this.url}/api/payments/quote`, quotePayload, { headers }).toPromise<any>();

      console.log({ response });
      Logger.info(response);
      return response;
    } catch (error) {
      Logger.error(`getPriceQuoteTransaction - ${inspect(error)}`);
    }
  }

  public async getEvent() {
    const jwt = await this.store.select(getJwtToken).pipe(take(1)).toPromise();

    const headers = new HttpHeaders({
      Authorization: `Bearer ${jwt}`,
    });
    const options = { headers };
    return this.http.get(`${this.url}/wallet/merchant/v2/events`, options).toPromise();
  }

  public async postPaymentRequest(quote_id: string, wallet_address: string, digital_currency: string) {
    try {
      let paymentPayload = {
        quote_id,
        destination_wallet: {
          currency: digital_currency,
          address: wallet_address
        }
      };

      const jwt = await this.getJwt();
      const headers = new HttpHeaders({
        Authorization: `Bearer ${jwt}`,
      });

      let paymentApiUrl = `${this.url}/api/payments/payment`;
      Logger.info(paymentApiUrl);
      let response = await this.http.post(paymentApiUrl, paymentPayload, { headers }).toPromise<any>();
      console.log({ response });
      Logger.info(response);
      return response;
    } catch (error) {
      Logger.error(`postPaymentRequest - ${inspect(error)}`);
    }
  }
}
